const colors = {
  red: '#e53935',
  green: '#4CAF50',
  grey: '#babdbe',
  primary: '#0d47a1',
  helper: '#081658',
};

export default colors;
